import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { TermlyCMP } from "../components";

export const withRouter = (Component) => (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  return (
    <>
      {process.env.REACT_APP_CONSENT_BANNER_UUID && (
        <TermlyCMP 
          websiteUUID={process.env.REACT_APP_CONSENT_BANNER_UUID} 
          autoBlock={true} 
          masterConsentsOrigin={process.env.REACT_APP_MASTER_CONSENTS_ORIGIN} 
        />
      )}
      <Component
        navigate={navigate}
        params={params}
        location={location}
        {...props}
      />
    </>
  );
};
